import { z } from 'zod';
import {
  attributeSchema,
  colorOptionSchema,
  productFeatureSchema,
  productSpecSchema,
  stockStatusSchema,
} from './product';

export { attributeSchema, colorOptionSchema };

export const adminProductSchema = z.object({
  id: z.string().optional(),
  slug: z.string().min(1, 'الرابط مطلوب'),
  nameAr: z.string().min(1, 'الاسم بالعربية مطلوب'),
  nameEn: z.string().default(''),
  brandId: z
    .string()
    .nullish()
    .transform((v) => (v && v.length > 0 ? v : null)),
  categoryId: z.string().min(1, 'القسم مطلوب'),
  descriptionAr: z.string().default(''),
  descriptionEn: z.string().default(''),
  price: z.number().nonnegative(),
  showPrice: z.boolean().default(true),
  isFeatured: z.boolean().default(false),
  isBestseller: z.boolean().default(false),
  isAvailable: z.boolean().default(true),
  isActive: z.boolean().default(true),
  sku: z.string().default(''),
  stock: z.number().int().nullable().optional(),
  imageUrl: z.string().default(''),
  wholesalePrice: z.number().nonnegative().nullable().optional(),
  attributes: z.array(attributeSchema).default([]),
  colors: z.array(colorOptionSchema).default([]),
  deviceIds: z.array(z.string()).default([]),
});

export const adminBrandSchema = z.object({
  id: z.string().optional(),
  slug: z.string().min(1, 'الرابط مطلوب'),
  nameAr: z.string().min(1, 'الاسم بالعربية مطلوب'),
  nameEn: z.string().min(1, 'الاسم بالإنجليزية مطلوب'),
  logoUrl: z.string().default(''),
  displayOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
  categoryIds: z.array(z.string()).default([]),
});

export const adminCategorySchema = z.object({
  id: z.string().optional(),
  slug: z.string().min(1, 'الرابط مطلوب'),
  nameAr: z.string().min(1, 'الاسم بالعربية مطلوب'),
  nameEn: z.string().min(1, 'الاسم بالإنجليزية مطلوب'),
  icon: z.string().default(''),
  imageUrl: z.string().default(''),
  displayOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});

export const adminDeviceSchema = z.object({
  id: z.string().optional(),
  brandId: z.string().min(1, 'العلامة التجارية مطلوبة'),
  nameAr: z.string().min(1, 'الاسم بالعربية مطلوب'),
  nameEn: z.string().default(''),
  slug: z.string().min(1, 'الرابط مطلوب'),
  imageUrl: z.string().default(''),
  isActive: z.boolean().default(true),
});

export type AdminProductInput = z.infer<typeof adminProductSchema>;
export type AdminBrandInput = z.infer<typeof adminBrandSchema>;
export type AdminCategoryInput = z.infer<typeof adminCategorySchema>;
export type AdminDeviceInput = z.infer<typeof adminDeviceSchema>;

export interface AdminProduct extends AdminProductInput {
  id: string;
}

export interface AdminBrand {
  id: string;
  slug: string;
  nameAr: string;
  nameEn: string;
  logoUrl: string;
  displayOrder: number;
  isActive: boolean;
  categoryIds: string[];
}

export interface AdminCategory {
  id: string;
  slug: string;
  nameAr: string;
  nameEn: string;
  icon: string;
  imageUrl: string;
  displayOrder: number;
  isActive: boolean;
}

export interface AdminDevice {
  id: string;
  brandId: string | null;
  nameAr: string;
  nameEn: string;
  slug: string;
  imageUrl: string;
  isActive: boolean;
}

export { stockStatusSchema, productSpecSchema, productFeatureSchema };
